import React from 'react';
import PropTypes from 'prop-types'
import $ from 'jquery'

import { Captcha, Email, CountrySelection, CreateAccountPre} from 'guest-payment';
import AddressEntryField from 'react-address-entry-field';

import PaymentComponent from '../../containers/payment-component';
import PhoneComponent from '../../containers/phone-component';
import NameComponent from '../../containers/name-component';

import AddressCheckbox from '../../components/addressCheckbox'
import GuestTerms from '../../components/guestTerms'

import AppActions from '../../actions/AppActions'
import AppStore from '../../stores/AppStore';

import { addShake, parseErrorResponse, parseValErrResp, getErrFields } from '../../utility/helper'
import '../../utility/csrf'
import CancelAndReturn from '../../components/cancelAndReturn'
import LinnerDiv from '../../components/lineDiv'

import * as FPT from '../../utility/fpt'
import constants from '../../utility/constants'
import { getCountryInfo } from '../../utility/localizer'
import TemplateData, { localsMessages, guestLocalsMessages } from '../../utility/getTemplateData'

import SignUpPanel from '../../components/signUpPanel'
import bootstrap from '../../../../node_modules/frontend-framework-paypal/dist/twbs/js/modal.js'

const errorMessages = localsMessages('errors/service')
const initialData = JSON.parse(document.getElementById('initialData').innerHTML || {})
const phoneNumberPatternDesc = initialData.phoneNumberPatternDesc || {}
const maxLength = phoneNumberPatternDesc.NATIONAL && phoneNumberPatternDesc.NATIONAL.maxLength || 10
const senderDetails = initialData.senderDetails || {}
const pre_address = senderDetails.address || {}

const defaultCardSpec = constants.DEFAULT_CARD_SPEC

export default React.createClass({

	contextTypes: {
		router: PropTypes.object.isRequired
	},

	propTypes: {
		password: PropTypes.string
	},

	getInitialState() {

		AppActions.changeCountry({ country: initialData.selectedCountry });

		return {
			isRequired: true,
			postcodeHasError: false,
			refreshingCaptcha: false,
			passwordFieldsOpen: false,
			legalCheckbox: false,
			guestAllowed: TemplateData.guestAllowed,
			memberMandatory: TemplateData.memberMandatory || false,
			charityCountry: TemplateData.charityCountry,
			validPassword: null,
			showPasswordValidationErrors: false,
			supportedCountries: initialData.supportedCountries,
			countriesAllowed: initialData.countriesAllowed,
			country: /*pre_address.iso_country ||*/  initialData.selectedCountry,
			DOBPattern: getCountryInfo(initialData.selectedCountry).DOBPattern,
			cardSpecs: initialData.cardSpecs,
			initialData: initialData,
			card: {
				type: '',
				number: '',
				securityCode: '',
				expiration: '',
				dateOfBirth: '',
				startDate: '',
				issueNumber: '',
			},
			cardSpec: defaultCardSpec,
			consentShareAddress: false,
			donateNow: '',
			agreeAndDonate: '',
			displayCaptcha: false,
			errorMessages: errorMessages,
			captchaObject: {},
			showServiceErrors: false,
			errorMesages: [],
			isRequired: true,
			errMessageCreditCard: '',
			errMessageExpiry: '',
			errMessageCSC: '',
			errMessageEmail: '',
			errMessagePhoneNumber: '',
			legalCheckboxErrorMsg: '',
			// Auto fill form
			firstname: senderDetails.first_name || '',
			lastname: senderDetails.last_name || '',
			newAddress: {
				line1: pre_address.address1 || '',
				line2: pre_address.address2 || '',
				city: pre_address.city || '',
				state: pre_address.state || '',
				postcode: pre_address.zip || '',
				country: pre_address.iso_country || ''
			},
			phone: {
				number: senderDetails.phone && senderDetails.phone.phone_number || '',
				type: '',
			},
			user: {
				firstName: senderDetails.first_name || '',
				lastName: senderDetails.last_name || '',
				email: senderDetails.sender_email || '',
				password: '',
				occupation: '',
				nationality: '',
				dateOfBirth: '',
				countryOfResidence: '',
			},
			email: senderDetails.sender_email || ''
		};
	},

	componentDidMount() {
		$('[type=password]').focus(() => { this.setState({ legalCheckboxErrorMsg: '' }) })
	},

	/*
	* Handle country change
	* Gets new props for new country
	* If country not allowed for guest, it will be redirect to legacy
	*/
	handleCountryChange(country) {

		let { charityCountry } = this.state;

		if (country !== initialData.selectedCountry) {
			AppActions.changeCountry({ country: country });

			this.setState({ country: country });
			// Beacons for country change
			FPT.trackLinkClickWithData('changeCountry', { country: country });
			$('.spinneroverlay').show();
			let { location: {pathname}} = window
			let {token, signup = false } = TemplateData
			let url = `/donate?token=${token}&country.x=${country}&locale.x=${country}&clientState=${pathname}?token=${token}`
			window.location.href = url
		}
	},

	handleScrollToError() {
		let errorEl = $('.vx_has-error-with-message:visible')
		setTimeout(()=>{ $('html, body').animate({ scrollTop: errorEl.offset().top }, 1000) }, 10)
		return
	},

	/*
	* Handling payment infomation
	*/
	handleChangePaymentInfo(card = {}) {
		this.setState({card: card});
	},

	/*
	* Handle last name change
	*/
	handleChangeNameInfo(firstName, lastName) {
		let { user = {} } = this.state;
		user.firstName = firstName;
		user.lastName = lastName;
		this.setState({ user: user });
	},

	/*
	* Handle any changes to biling address fields
	*/
	handleChangeBillingField(field, value) {
		let newAddress = { ...this.state.newAddress, [field]: value }
		this.setState({ newAddress: newAddress, showAddressErrors: false });
	},

	/*
	* Handle email change
	*/
	handleChangeEmail(email) {
		let { user = {} } = this.state;
		user.email = email
		this.setState({ user: user, email: email });
	},

	/*
	* Handle email blur
	*/
	handleEmailBlur (email) {
		let errCodeEmail = ''
		let emailRex = constants.EMAIL_REX;
		let cusEmail = TemplateData.donationEmail;
		if (emailRex.test(email)) {
			if (cusEmail === email) {
				errCodeEmail = 'CANNOT_PAY_SELF';
			}
		} else if (email === '') {
			errCodeEmail = 'MISSING_EMAIL_ID';
		} else {
			errCodeEmail = 'INVALID_EMAIL_ID';
		}

		let errMessageEmail = errorMessages[errCodeEmail];
		FPT.trackError({ message: errMessageEmail, fieldId: 'email',  code: errCodeEmail});
		this.setState({ errMessageEmail: errMessageEmail });
	},

	/*
	* Handle email error
	*/
	handleExistEmailError(key) {
		let errMessageEmail = errorMessages[key];
		this.setState({ errMessageEmail: errMessageEmail });
		FPT.trackError({ message: errMessageEmail, fieldId: 'email',  code: key});
		this.handleScrollToError()
	},

	/*
	* Handling phone infomation
	*/
	handlePhoneInfo(phone = {}) {
		this.setState({ phone: phone });
	},

	/*
	* Handle postal code error
	*/
	handlePostcodeHasError(postcode) {
		this.setState({ postcode: postcode });
	},

	/*
	* Handle change in create account checkbox
	*/
	handleCreateAccountCheckbox(checked) {
		let chkBxStatus = checked ? 'checked' : 'unchecked'
		FPT.trackLinkClickWithData('createAccount', { checkbox: chkBxStatus })
		this.setState({ passwordFieldsOpen: checked });
	},

	/*
	* When the account creation form has all the valid input then save it.
	*/
	handleCreateAccountAddInfo(updateUser) {
		let { user = {} } = this.state;
		user.dateOfBirth = updateUser.dateOfBirth;
		user.nationality = updateUser.nationality;
		user.occupation = updateUser.occupation;
		user.password = updateUser.password;
		user.legalValid = updateUser.legalValid;
		user.consentCommunication = updateUser.consentCommunication;
		this.setState({ user: user });
	},

	/*
	* Handle reset of all saved fields from account creation form.
	*/
	handleCreateAccountResetInfo() {
		let { user = {} } = this.state;
		user.dateOfBirth = null
		user.nationality = null
		user.occupation = null
		user.password = null
		user.legalValid = null
		user.consentCommunication= false
		this.setState({ user: user });
	},

	/*
	* Handle share  address checkbox
	*/
	handleShareAddress(isChecked) {
		this.setState({consentShareAddress: isChecked});
	},

	/*
	* Handle  address errors
	*/
	handleAddressErrors(errObj) {
		let errFields = JSON.stringify(errObj.fields)
		let errorMessage = errorMessages.INVALID_BILLING_ADDRESS_CITY_STATE_ZIP;

		this.setState({ showAddressErrors: true, addressErrorMessage: errorMessage });
		FPT.trackError({ message: errorMessage, fieldId: errFields,  code: 'INVALID_BILLING_ADDRESS_CITY_STATE_ZIP'});
		this.handleScrollToError()
	},

	/*
	* Handle focus on input
	*/
	handleFocus(key) {
		 var ele = {}
		ele[key] = ''
		this.setState(ele)
	},

	/*
	* Handle any default value from server - Auto populate
	*/
	handleAddressDefaultValue (item) {
		let keyName = item && item.$
		switch (keyName) {
			case 'line1':
				return pre_address['address1'] || ''
				break;
			case 'line2':
				return pre_address['address2'] || ''
				break;
			case 'city':
				return pre_address['city'] || ''
				break;
			case 'state':
				return pre_address['state'] || ''
				break;
			case 'postcode':
				return pre_address['zip'] || ''
				break;
			default:
				return ''
		}
	},

	/*
	* Handle field level errors
	*/
	setFieldErrors(response) {
		let errorFileds = getErrFields(response);
		let messages = [];
		let showServiceErrors = false;

		for (let i in errorFileds) {
			let errObj = errorFileds[i];
			let key = errorFileds[i].type;

			switch (key) {
				case 'INVALID_CARD_NUMBER':
					this.childPaymentInfo.handleCardNumberError('INVALID_CARD_NUMBER');
					this.handleScrollToError();
					break;
				case 'REQUIRED_CARD_NUMBER':
					this.childPaymentInfo.handleCardNumberError('REQUIRED_CARD_NUMBER');
					this.handleScrollToError();
					break;
				case 'INVALID_SECURITY_CODE':
					this.childPaymentInfo.handleSecurityCodeError('INVALID_SECURITY_CODE');
					this.handleScrollToError();
					break;
				case 'REQUIRED_SECURITY_CODE':
					this.childPaymentInfo.handleSecurityCodeError('REQUIRED_SECURITY_CODE');
					this.handleScrollToError();
					break;
				case 'INVALID_EXPIRY':
					this.childPaymentInfo.handleExpirationError('INVALID_EXPIRY');
					this.handleScrollToError();
					break;
				case 'REQUIRED_EXPIRY':
					this.childPaymentInfo.handleExpirationError('REQUIRED_EXPIRY');
					this.handleScrollToError();
					break;
				case 'REQUIRED_FIRST_NAME':
					this.childNameInfo.handleFirstNameError('REQUIRED_FIRST_NAME');
					this.handleScrollToError();
					break;
				case 'INVALID_FIRST_NAME':
					this.childNameInfo.handleFirstNameError('INVALID_FIRST_NAME');
					this.handleScrollToError();
					break;
				case 'REQUIRED_LAST_NAME':
					this.childNameInfo.handleLastNameError('REQUIRED_LAST_NAME');
					this.handleScrollToError();
					break;
				case 'INVALID_LAST_NAME':
					this.childNameInfo.handleLastNameError('INVALID_LAST_NAME');
					this.handleScrollToError();
					break;
				case 'INVALID_BILLING_ADDRESS_CITY_STATE_ZIP':
					this.handleAddressErrors(errObj)
					break;
				case 'INVALID_PHONE_NUMBER':
					this.childPhoneInfo.handlePhoneError('INVALID_PHONE_NUMBER')
					break;
				case 'REQUIRED_PHONE_NUMBER':
					this.childPhoneInfo.handlePhoneError('REQUIRED_PHONE_NUMBER')
					break;
				case 'ACCOUNT_ALREADY_EXISTS':
					this.handleExistEmailError('ACCOUNT_ALREADY_EXISTS')
					break;
				case 'MISSING_EMAIL_ID':
					this.handleExistEmailError('MISSING_EMAIL_ID')
					break;
				default:

					showServiceErrors = true;
					let message = errorMessages[key] || errorMessages.VALIDATION_ERROR ;
					if (message) {
						messages.push({ key: i, value: message })
					}
					FPT.trackError({ message: message, fieldId: JSON.stringify(errObj && errObj.fields),  code: key});
			}
		}
		// Updating store with any error messages from server.
		AppActions.updateServerErrors({ serverErrors: messages });
	},

	handleSubmitAnswer (event) {},

	/*
	* Handling refesh captcha
	* When user clicks on refesh button
	*/
	handleRefreshCaptcha(event) {
		this.setState({ displayCaptcha: false, refreshingCaptcha: true });

		$.post('/donate/generatecaptcha').then((result) => {
			if (result && result.data && result.data.captcha) {
				this.setState({ displayCaptcha: true, refreshingCaptcha: false, captchaObject: result.data.captcha });
				window.setTimeout(() => $('.spinneroverlay').hide(), 500);
			}
		}).always(() => $('.spinneroverlay').hide())
	},

	handleCreateGuest(event) {
		event.preventDefault();

		let { user } = this.state;
		if ((this.state.passwordFieldsOpen || TemplateData.memberMandatory) && !user.password) {
			this.setState({ showPasswordValidationErrors: true, createaccount: true });
			if (!user.password) { return }
		}

		let cusEmail = TemplateData.donationEmail;
		if (cusEmail === this.state.email) {
			this.setState({ errMessageEmail: errorMessages.CANNOT_PAY_SELF });
		}
		if (!AppStore.getDonationAmount() || parseFloat(AppStore.getDonationAmount()) < 0.01) {
			addShake()
			$('html, body').animate({ scrollTop: $('.money_input').offset().top	}, 1000);
			return; // block the createGuest action
		}
		if ($('.vx_has-error-with-message').is(':visible')) {
			this.handleScrollToError();
			return
		} else {
			this.setGuestPaymentData()
		}
	},

	/*
	* setting up guest payment data before executing guest payment.
	*/
	setGuestPaymentData() {
		let myData = AppStore.getAllData() || {};
		const { memberMandatory } = TemplateData;
		const { user = {}, card = {}, phone = {}, newAddress = {}, consentShareAddress, passwordFieldsOpen, consentCommunication = false, DOBPattern } = this.state;
		const { startDate: {startMonth, startYear} = {} } = card;
		let billingAddress = {
			line1: newAddress.line1,
			city: newAddress.city,
			postalCode: newAddress.postcode,
			postcode: newAddress.postcode, // Griffin has `postcode`
			country: myData.country
		}
		if (newAddress.line2) {
			billingAddress.line2 = newAddress.line2
		}

		if (newAddress.state) {
			billingAddress.state = newAddress.state
		}

		if (card.expiration) {
			let [ expiryMonth = '', expiryYear = '' ] = card.expiration.split('/');
			card.expiryMonth = expiryMonth
			card.expiryYear = (expiryYear.length === 2) ? '20' + expiryYear : expiryYear;
		}

		if (card.dateOfBirth && DOBPattern) {
			let dobDateCard = card.dateOfBirth.split('/');
			let patternsCard = DOBPattern.split('/');

			card.dobYear = dobDateCard[patternsCard.indexOf('YYYY')]
			card.dobMonth = dobDateCard[patternsCard.indexOf('MM')]
			card.dobDay = dobDateCard[patternsCard.indexOf('DD')]
		}

		myData.user = user
		myData.card = card
		myData.phone = phone
		myData.consentShareAddress = consentShareAddress
		myData.billingAddress = billingAddress;

		if (startMonth && startYear) {
			myData.startDate = `${startMonth}/${startYear}`
			myData.card.startYear = startYear
			myData.card.startMonth = startMonth
		}

		myData.createaccount = memberMandatory ? memberMandatory : passwordFieldsOpen;

		if (passwordFieldsOpen || memberMandatory) {
			myData.marketingOptin = consentCommunication;
		} else {
			myData.user.password = '';
		}

		if (myData.user.dateOfBirth && DOBPattern) {
			let dobDate = myData.user.dateOfBirth.split('/');
			let patterns = DOBPattern.split('/');

			myData.user.dobYear = dobDate[patterns.indexOf('YYYY')]
			myData.user.dobMonth = dobDate[patterns.indexOf('MM')]
			myData.user.dobDay = dobDate[patterns.indexOf('DD')]
		}

		if ($('[name=captchaImage]').is(':visible')) {
			myData.captchaAnswer = $('[name=captchaImage]').val()
		}

		this.setState({ showAddressErrors: false });

		// Updating app store with message = [], as attempt to clean all server errors.
		AppActions.updateServerErrors({ serverErrors: [] });
		AppActions.updateEmail({email: this.state.email});
		AppActions.updateBillingAddress({billingAddress: billingAddress});

		this.handleRequiredValues(myData);
	},

	handleEmailRequiredFields(params) {
		let isValid = true;
		let emailErr;
		let keysToValidate = Object.keys(params);

		keysToValidate.forEach((key) => {
			let value = params[key];
			switch (key) {
				case 'email':
					if (!value) {
						isValid = false;
						emailErr = errorMessages.MISSING_EMAIL_ID;
						FPT.trackError({ message: emailErr, fieldId: 'email',  code: 'MISSING_EMAIL_ID'});
					}
					break;
				default:
					break;
			}
		})
		this.setState({ errMessageEmail: emailErr })
		return isValid
	},

	// parseAddress

	handleAddressRequiredFields (billingAddress){
		let { initialData: { addressEntryFormat = {}, addressReqFields = {} } } = this.state;
		let { allErr = [], isValid = true } = {};

		addressEntryFormat.layout.filter(field => {
			if (field.required && field.$ && !billingAddress[field.$]) {
				isValid = false;
				let errKeyName = ''
				switch (field.$) {
					case 'line1':
						errKeyName = 'REQUIRED_ADDRESS_LINE1'
						break;
					case 'postcode':
						errKeyName = 'REQUIRED_BILLING_ADDRESS_ZIP'
						break
					default:
						errKeyName = `REQUIRED_BILLING_ADDRESS_${field.$.toUpperCase()}`
				}
				allErr.push({ key: field.$, value: errorMessages[errKeyName] })
			}
		})
		AppActions.updateServerErrors({ serverErrors: allErr })
		return isValid;
	},
	/*
	* Handling required form fields before executing guest payment
	*/
	handleRequiredValues (params){

		let paymentStatus = this.childPaymentInfo.handleRequiredFields(params.card);
		let phoneStatus = this.childPhoneInfo.handleRequiredFields(params.phone);
		let userStatus = this.childNameInfo.handleRequiredFields(params.user);
		let emailStatus = this.handleEmailRequiredFields(params.user);
		let addressStatus = this.handleAddressRequiredFields(params.billingAddress);

		if (paymentStatus && phoneStatus && emailStatus && addressStatus) {
			this.submitGuestPayment(params)
		} else {
			setTimeout(() => { this.handleScrollToError() }, 100)
		}
	},

	/*
	* Executing guest payment
	*/
	submitGuestPayment(params) {
		$('.spinneroverlay').show()
		if (this.state.consentShareAddress) {
			FPT.trackLinkClickWithData('consentShareAddress', { consentShareAddress: 'true' })
		}
		FPT.trackLinkClick('donate');

		$.post('/donate/guest', params, (result) => {

			// console.log('Result :: ', result);
			if (result.status === 'redirect') {

				window.location.href = result.url;

			} else if (result.code === 'captcha') {

				this.setState({ displayCaptcha: true, captchaObject: result.captcha });

			} else if (result.code === 'CROSS_BORDER' && result.fundingOpts) {

				let fundingOpts = result.fundingOpts[0]
				// Updating store with funding options
				AppActions.updateFundingOptions({ fundingOptions: fundingOpts })

				// Redirect to crossborder handler page.
				this.context.router.push('/donate/guest/crossborder');

			} else if (result.data && result.data.confirmationData) {

				let confirmationData = result.data.confirmationData || {}

				this.handlePaymentSuccess(confirmationData)

			} else if (result.data && result.data.error) {

				let messages = parseErrorResponse(result.data.error, errorMessages)

				// Updating store with any error messages from server.
				AppActions.updateServerErrors({ serverErrors: messages })

			} else if (result.code === 'VALIDATION_ERROR') {

				this.setFieldErrors(result)

			} else if (result.message === 'CC_LINKED_TO_FULL_ACCOUNT') {

				let messages = parseValErrResp(result, errorMessages, 'CC_LINKED_TO_FULL_ACCOUNT')

				// Updating store with any error messages from server.
				AppActions.updateServerErrors({ serverErrors: messages })

			} else if (result.message === 'ISSUER_DECLINE_ERROR') {

				let messages = parseValErrResp(result, errorMessages, 'ISSUER_DECLINE_ERROR')

				// Updating store with any error messages from server.
				AppActions.updateServerErrors({ serverErrors: messages })

			} else if (result.message === 'RISK_DISALLOWED') {

				let messages = parseValErrResp(result, errorMessages, 'RISK_DISALLOWED')

				// Updating store with any error messages from server.
				AppActions.updateServerErrors({ serverErrors: messages })
			} else {
				window.location.href = '/donate/error/payment';
			}
		}).fail(() => {
			// Handle any wierd errors from service
			 window.location.href = '/donate/error/payment';

		}).always(() => {

			$('.spinneroverlay').hide();
			// Checking if captcha exists, simply refreshing after every form submission.
			if (this.state.displayCaptcha) {
				this.handleRefreshCaptcha()
			}
		})
	},

	handlePaymentSuccess(response) {

		AppActions.updateConfirmation({ confirmation: response });

		if (response.guestSignUp && response.experiment && response.experiment.treatment_name === 'US_cause_guest_donation_flow_treatment') {

			FPT.trackPageWithData('main:donate:wps:guest:upgrade', 'main:donate:wps:guest:upgrade:web::', { xe: response.experiment.experiment_id, xt: response.experiment.treatment_id })
			$('#guestCreateAccountdialog').modal('show')

		} else	if (response.guestSignUp && response.experiment && response.experiment.treatment_name === 'US_cause_guest_donation_flow_control') {

			FPT.addPxpTags({ xe: response.experiment.experiment_id, xt: response.experiment.treatment_id })
			return this.handleConfirmation(response)

		} else {
			return this.handleConfirmation(response)
		}
	},

	/*
	* Handling guest payment confirmation page after payment is done
	* case 1 : success payment
	* case 2 : pending payment
	*/
	handleConfirmation(response) {
		if (response.isOfacPending) {
			this.context.router.push('/donate/guest/pending')
		} else {
			this.context.router.push('/donate/guest/confirmation')
		}
	},

	render() {

		const allGuestMessages = guestLocalsMessages();
		const signUpHeader =  allGuestMessages.createAccountPreProps && allGuestMessages.createAccountPreProps.mainTitle2;
		const { guestLabels, guestCaptcha: guestCaptchaLabels, guestHelp: guestHelpLabels } = allGuestMessages
		const donateNowLabel = (this.state.passwordFieldsOpen || TemplateData.memberMandatory) ? guestLabels.agreeanddonate : guestLabels.donatenow

		allGuestMessages.createAccountPreProps.mainTitle = TemplateData.memberMandatory ? signUpHeader : ''

		let { initialData: { examplePhoneNumber, addressEntryFormat = {}, supportedCountries = [] } } = this.state

		let fields = addressEntryFormat.layout.filter(field => field._ !== undefined);
		let labels = addressEntryFormat.strings;

		let recieveMailLabel = guestLabels.recieveMail
		let recieveMailToolTip = guestLabels.recieveMailToolTip
		let orgName =  TemplateData.donationName;

		recieveMailLabel = recieveMailLabel.replace('{orgName}', orgName);
		recieveMailToolTip = recieveMailToolTip.replace('{orgName}', orgName);
		recieveMailToolTip = recieveMailToolTip.replace('{orgName}', orgName);

		return (<div className="donate_guest_form_wrapper">
					<SignUpPanel {...allGuestMessages.createAccountPost} email={this.state.email}/>
					<div className="row">
						<div className="col-xs-12 col-sm-12 col-md-12 text-center">
							<CountrySelection
								supportedCountries={this.state.supportedCountries}
								defaultValue={this.state.country}
								changeCountry={(country) => this.handleCountryChange(country)}/>
						</div>
					</div>
				<div className="row">
					<div className="col-xs-12 col-sm-12 col-md-12 text-center creditcard_number">
						<PaymentComponent
							onRef={ref => (this.childPaymentInfo = ref)}
							changePaymentInfo={this.handleChangePaymentInfo}
							country={this.state.country}
							{...allGuestMessages}
							errorMessages={errorMessages}
							{...this.state.initialData}/>
					</div>
				</div>
				<div className="row has_combo">
					<div className="col-xs-12 col-sm-12 col-md-12 text-center creditcard_number">
						<NameComponent
							onRef={ref => (this.childNameInfo = ref)}
							{...allGuestMessages}
							errorMessages={errorMessages}
							isRequired={this.state.isRequired}
							{...this.state.initialData}
							guestLabels={guestLabels}
							changeNameInfo={this.handleChangeNameInfo}
							user={this.state.user}/>
					</div>
				</div>
				{this.state.showAddressErrors &&
					<div className="col-xs-12 col-sm-12 col-md-12 service_error_holder vx_has-error-with-message">
						<p className="text-left">
							<span className="vx_alert-icon icon icon-small icon-critical-small" aria-hidden="true"></span>
							{this.state.addressErrorMessage}
						</p>
					</div>}
				{/*<label id="guestBillingLabel"
					style={{ width: '100%', marginTop: 5, textAlign: 'left', fontWeight: 'bold' }} >
					{guestLabels.billing}
				</label>*/}
				<p className="vx_text-4" style={{ marginTop: 10, marginBottom: 10, fontFamily: 'pp-sans-big-light', fontSize: 18 }}>{guestLabels.billing}</p>
				<div className="row address_fields"
					style={{ marginTop: -10 }}>
					{fields.map(field =>
						<AddressEntryField
							key={`${field.$}`}
							{...field}
							id={`billing_${field.$}`}
							value={this.handleAddressDefaultValue(field)}
							fieldName={field.$}
							labels={labels}
							country={this.state.country}
							handleChangeField={this.handleChangeBillingField}
							handlePostcodeHasError={this.handlePostcodeHasError}/>)}
				</div>

				{TemplateData.isShipping && <AddressCheckbox changeAddress={this.handleShareAddress} label={recieveMailLabel} toolTipText={recieveMailToolTip}/>}

				{/*<label id="guestContactInfLabel"
					style={{ width: '100%', marginTop: 5, marginBottom: 0, textAlign: 'left', fontWeight: '' }}>
					{guestLabels.contactinfo}
				</label>*/}
				<p className="vx_text-4" style={{ marginTop: 10, marginBottom: 10, fontFamily: 'pp-sans-big-light', fontSize: 18 }}>{guestLabels.contactinfo}</p>
				<div className="row  has_combo">
					<div className="col-xs-12 col-sm-12 col-md-12 ">
						<PhoneComponent
							onRef={ref => (this.childPhoneInfo = ref)}
							{...allGuestMessages}
							{...this.state.initialData}
							errorMessages={errorMessages}
							isRequired={this.state.isRequired}
							handlePhoneInfo={this.handlePhoneInfo}/>
					</div>
				</div>
				<div style={{ marginTop: '-10px' }} className="email_holder">
					<Email label={guestLabels.email}
						handleFocus={() => this.handleFocus('errMessageEmail')}
						errorMessage={this.state.errMessageEmail}
						handleBlur={this.handleEmailBlur}
						value={this.state.email}
						required={this.state.isRequired}
						changeEmail={this.handleChangeEmail}/>
				</div>
				<div>
					<div className="password_fields" style={{ marginTop: 20, textAlign: 'initial', fontFamily: 'pp-sans-big-regular' }}>
						<CreateAccountPre {...allGuestMessages.createAccountPreProps}
							mandatory={this.state.memberMandatory}
							country={this.state.country}
							supportedCountries={this.state.supportedCountries}
							handleCreateAccountCheckbox={this.handleCreateAccountCheckbox}
							handleValidInfo={() => { }}
							resetValidInfo={() => { }}
							handleAllValidInfo={this.handleCreateAccountAddInfo}
							resetAllValidInfo={this.handleCreateAccountResetInfo}
							showValidationErrors={this.state.showPasswordValidationErrors}/>
					</div>
				</div>

			{this.state.refreshingCaptcha ?
				<div className="col-xs-12 col-sm-12 col-md-12 loading_captcha_holder">
					<div className="smalldonatespinner">
						<div className="spinnerholder">
							<div className="spinner"></div>
						</div>
						<div className="loadingcontent">
							<p className="">{guestLabels.refreshingCaptcha}</p>
						</div>
					</div>
				</div> : null}
			<GuestTerms />

			{this.state.displayCaptcha ?
				<div className="captcha_holder">
					<Captcha
						captchaObject={this.state.captchaObject}
						refreshContent={guestCaptchaLabels.refresh}
						submitContent={guestCaptchaLabels.verify}
						textInputLabel={guestCaptchaLabels.codelabel}
						toggleAudioContent="ToggleAudioContent"
						submitAnswer={this.handleSubmitAnswer}
						refreshCaptcha={this.handleRefreshCaptcha}/>
				</div> : null}

			<div style={{ maxWidth: 360, margin: '20px auto 0px' }}>
				<button type="button"
					style={{ marginBottom: '0px' }}
					id="guestPaymentBtn"
					className="vx_btn vx_btn-block"
					onClick={this.handleCreateGuest} >
					{donateNowLabel}
				</button>
			</div>
			<CancelAndReturn />
		</div>
		);
	}
});



// WEBPACK FOOTER //
// ./pages/guest/guestForm.js